import * as globals from '@wandb/weave/common/css/globals.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const ContactSalesLink = styled(TargetBlank)`
  display: inline-flex;
  align-items: center;
  color: ${globals.gray500};
  &:hover {
    color: ${globals.gray500};
  }
`;
